<template>
    <div class="animated fadeIn">
        <b-container class="w-100 px-0">
            <b-row class="m-0 py-2 px-2 w-100">
                <b-container class="p-0">
                    <b-form @submit.prevent="store" enctype="multipart/form-data">
                        <b-row class="bg-light m-0 p-3">
                            <b-row class="w-100 m-0 p-0">
                                <h5 class="border-bottom mb-2 text-primary w-100">GESTORES</h5>
                            </b-row>

                            <b-row class="w-100 m-0 p-0 pb-2">
                                <b-col lg="10" offset-lg="1" md="12">
                                    <b-form-group label="<strong>Gestor Comercial</strong>" label-for="businessManager"
                                        label-cols="5" :horizontal="true" class="w-100 mt-2 mb-0 text-right">
                                        <multiselect name="businessManager" v-model="entity.businessManager"
                                            :options="this.commercialUsers.map(user => user.uuid)" :multiple="false"
                                            :allowEmpty="true" placeholder="Seleccione" selectLabel="+"
                                            deselectLabel="-" autocomplete="nope">
                                            <template slot="singleLabel" slot-scope="props">
                                                {{commercialUsers.find(user => user.uuid == props.option).firstname}} {{commercialUsers.find(user => user.uuid == props.option).lastname}}
                                            </template>
                                             <template slot="option" slot-scope="props">
                                                <small>{{commercialUsers.find(user => user.uuid == props.option).firstname}} {{commercialUsers.find(user => user.uuid == props.option).lastname}}</small>
                                                <pre>{{commercialUsers.find(user => user.uuid == props.option).department}}</pre>
                                            </template>

                                        </multiselect>
                                    </b-form-group>

                                    <b-form-group label="<strong>Gestor de Afiliación</strong>"
                                        label-for="affiliationManager" label-cols="5" :horizontal="true"
                                        class="w-100 mt-3 mb-0 text-right">
                                        <multiselect name="affiliationManager" v-model="entity.affiliationManager"
                                            :options="this.affiliationUsers.map(user => user.uuid)"
                                            :multiple="false" :allowEmpty="true" placeholder="Seleccione"
                                            selectLabel="+" deselectLabel="-" autocomplete="nope">
                                            <template slot="singleLabel" slot-scope="props">
                                                {{affiliationUsers.find(user => user.uuid == props.option).firstname}} {{affiliationUsers.find(user => user.uuid == props.option).lastname}}
                                            </template>
                                             <template slot="option" slot-scope="props">
                                                <small>{{affiliationUsers.find(user => user.uuid == props.option).firstname}} {{affiliationUsers.find(user => user.uuid == props.option).lastname}}</small>
                                                <pre>{{affiliationUsers.find(user => user.uuid == props.option).department}}</pre>
                                            </template>
                                        </multiselect>
                                    </b-form-group>

                                    <b-form-group label="<strong>Gestor de devoluciones</strong>"
                                        label-for="returnManager" label-cols="5" :horizontal="true"
                                        class="w-100 mt-3 mb-0 text-right">
                                        <multiselect name="returnManager" v-model="entity.returnManager"
                                            :options="this.refundUsers.map(user => user.uuid)"
                                            :multiple="false" :allowEmpty="true" placeholder="Seleccione"
                                            selectLabel="+" deselectLabel="-" autocomplete="nope">
                                            <template slot="singleLabel" slot-scope="props">
                                                {{refundUsers.find(user => user.uuid == props.option).firstname}} {{refundUsers.find(user => user.uuid == props.option).lastname}}
                                            </template>
                                             <template slot="option" slot-scope="props">
                                                <small>{{refundUsers.find(user => user.uuid == props.option).firstname}} {{refundUsers.find(user => user.uuid == props.option).lastname}}</small>
                                                <pre>{{refundUsers.find(user => user.uuid == props.option).department}}</pre>
                                            </template>
                                        </multiselect>
                                    </b-form-group>
                                </b-col>
                            </b-row>
                        </b-row>

                        <b-row class="pt-4 m-0 mb-4 pb-0">
                            <div class="px-0 col float-left">
                                <button type="submit" class="btn btn-brand btn-primary btn-lg pull-right"
                                    v-if="mixinCheckPermission('EDIT_MEMBER_MANAGERS')">Guardar
                                </button>
                            </div>
                        </b-row>
                    </b-form>
                </b-container>

                <hr />

                <b-container class="p-0">

                    <b-row class="m-0 mt-4">
                        <b-card class="w-100">
                            <b-row slot="header" class="m-0 p-0 justify-content-between align-items-center">
                                <span>Convenios</span>
                                <span v-if="mixinCheckPermission('EDIT_MEMBER_AGREEMENTS')" class="btn p-0"
                                    @click="showAddAgreementForm">
                                    <i class="fa fa-plus"></i>
                                </span>
                            </b-row>

                            <v-client-table ref="AgreementTable" class="dataTable" md="12" lg="12" sm="12"
                                :columns="table.agreement.columns" :data="myAgreements"
                                :options="table.agreement.options" :theme="table.agreement.theme">

                                <template slot="applicationDate" slot-scope="props">
                                    {{ new Date(props.row.applicationDate) | dateFormat('DD/MM/YYYY') }}
                                </template>

                                <template slot="validUntil" slot-scope="props">
                                    {{ new Date(props.row.validUntil) | dateFormat('DD/MM/YYYY') }}
                                </template>

                                <template slot="uuid" slot-scope="props">
                                    <span class="btn py-0 px-2" @click="showAgreement(props.row.uuid)">
                                        <i class="fa fa-info"></i>
                                    </span>
                                    <span v-if="mixinCheckPermission('EDIT_MEMBER_AGREEMENTS')" class="btn py-0 px-2"
                                        @click="deleteAgreement(props.row.uuid)">
                                        <i class="fa fa-trash"></i>
                                    </span>
                                </template>
                            </v-client-table>
                        </b-card>

                        <b-modal ref="infoAgreementModal" hide-footer size="sm" title="Información de convenio" centered
                            class="text-center">
                            <p>
                                <b>Nombre:</b> {{ selectedAgreement.name }}
                            </p>
                            <p>
                                <b>Entidad:</b> {{ selectedAgreement.entity }}
                            </p>
                            <p>
                                <b>Tipo:</b> {{ getAgreementTypeName(selectedAgreement.type) }}
                            </p>
                            <p>
                                <b>Inicio:</b> {{ new Date(selectedAgreement.start_date) | dateFormat('DD/MM/YYYY') }}
                            </p>
                            <p>
                                <b>Fin:</b> {{ new Date(selectedAgreement.end_date) | dateFormat('DD/MM/YYYY') }}
                            </p>
                            <p v-if="!!selectedAgreement.headquarters && selectedAgreement.headquarters.length">
                                <b>Sedes:</b>
                                <b-badge v-for="headquarter in selectedAgreement.headquarters" :key="headquarter.uuid"
                                    pill variant="primary" class="m-1 p-2">
                                    {{ headquarter.name }}
                                </b-badge>
                            </p>
                        </b-modal>

                        <b-modal ref="addAgreementModal" hide-footer size="md" title="Aplicar Convenio" centered
                            @hidden="resetNewAgreement">
                            <b-form @submit.prevent="addAgreement">
                                <b-row>
                                    <b-col offset-md="1" md="10">
                                        <b-form-group label="<strong>Convenio *</strong>" label-for="agreement"
                                            :horizontal="true" class="w-100 mt-2 mb-0 text-left">
                                            <common-agreement-selector :headquartersId="entity.headquartersId"
                                                v-model="newAgreement.agreement"></common-agreement-selector>
                                        </b-form-group>
                                    </b-col>
                                </b-row>
                                <b-row class="mt-3">
                                    <b-col offset-md="1" md="10">
                                        <b-form-group label="<strong>Fecha de aplicación</strong>"
                                            label-for="applicationDate" :horizontal="true" class="w-100 mb-3 text-left">
                                            <v-date-picker name="applicationDate" v-model='newAgreement.applicationDate'
                                                class="p-0 form-control date-picker-w-100 date-picker-custom-border"
                                                :required="true">
                                            </v-date-picker>
                                        </b-form-group>
                                    </b-col>
                                </b-row>
                                <b-row class="border-top mt-4 pt-3 px-3 flex-row-reverse">
                                    <button type="submit" class="btn btn-brand btn-primary col-auto btn-lg float-right"
                                        sm="12" :disabled="!newAgreement.agreement">
                                        Guardar
                                    </button>
                                </b-row>
                            </b-form>
                        </b-modal>
                    </b-row>

                    <!-- ASSOCIATED PROJECT SECTION -->
                    <b-row class="m-0 mt-4">
                        <b-card class="w-100">
                            <b-row slot="header" class="m-0 p-0 justify-content-between align-items-center">
                                <span>Proyectos Asociados</span>
                                <span v-if="mixinCheckPermission('EDIT_MEMBER_ASSOCIATED_PROJECTS')" class="btn p-0"
                                    @click="showAddAssociatedProjectForm">
                                    <i class="fa fa-plus"></i>
                                </span>
                            </b-row>

                            <v-client-table ref="AssociatedProjectTable" class="dataTable" md="12" lg="12" sm="12"
                                :columns="table.associatedProject.columns" :data="myAssociatedProjects"
                                :options="table.associatedProject.options" :theme="table.associatedProject.theme">

                                <template slot="applicationDate" slot-scope="props">
                                    {{ new Date(props.row.applicationDate) | dateFormat('DD/MM/YYYY') }}
                                </template>

                                <template slot="uuid" slot-scope="props">
                                    <span v-if="mixinCheckPermission('EDIT_MEMBER_ASSOCIATED_PROJECTS')"
                                        class="btn py-0 px-2" @click="deleteAssociatedProject(props.row.uuid)">
                                        <i class="fa fa-trash"></i>
                                    </span>
                                </template>
                            </v-client-table>
                        </b-card>

                        <b-modal ref="addAssociatedProjectModal" hide-footer size="lg" title="Aplicar Proyecto Asociado"
                            centered @hidden="resetNewAssociatedProject">
                            <b-form @submit.prevent="addAssociatedProject">
                                <b-row>
                                    <b-col offset-md="1" md="10">
                                        <b-form-group label="<strong>Proyecto Asociado *</strong>" label-for="agreement"
                                            :horizontal="true" class="w-100 mt-2 mb-0 text-left">
                                            <multiselect name="agreement"
                                                v-model="newAssociatedProject.associatedProject"
                                                :options="memberAssociatedProjects" label="name" track-by="uuid"
                                                :multiple="false" :allowEmpty="false" placeholder="Seleccione"
                                                selectLabel="+" deselectLabel="-"></multiselect>
                                        </b-form-group>
                                    </b-col>
                                </b-row>
                                <b-row class="mt-3">
                                    <b-col offset-md="1" md="10">
                                        <b-form-group label="<strong>Fecha de aplicación</strong>"
                                            label-for="applicationDate" :horizontal="true" class="w-100 mb-3 text-left">
                                            <v-date-picker name="applicationDate"
                                                v-model='newAssociatedProject.applicationDate'
                                                :min-date='newAssociatedProject.associatedProject != null ? newAssociatedProject.associatedProject.startDate : null'
                                                :max-date='newAssociatedProject.associatedProject != null ? newAssociatedProject.associatedProject.endDate : null'
                                                class="col-3 p-0 form-control date-picker-w-100 date-picker-custom-border"
                                                :required="true">
                                            </v-date-picker>
                                        </b-form-group>
                                    </b-col>
                                </b-row>
                                <b-row class="border-top mt-4 pt-3 px-3 flex-row-reverse">
                                    <button type="submit" class="btn btn-brand btn-primary col-auto btn-lg float-right"
                                        sm="12"
                                        :disabled="!newAssociatedProject.associatedProject || !newAssociatedProject.applicationDate">
                                        Guardar
                                    </button>
                                </b-row>
                            </b-form>
                        </b-modal>
                    </b-row>

                    <b-row class="m-0">
                        <b-card class="w-100">
                            <b-row slot="header" class="m-0 p-0 justify-content-between align-items-center">
                                <span>Socios Vinculados</span>
                                <span v-if="mixinCheckPermission('EDIT_MEMBER_LINKED')" class="btn p-0"
                                    @click="showCreateUnlinkedForm()">
                                    <i class="fa fa-plus"></i>
                                </span>
                            </b-row>

                            <v-client-table ref="UnlinkedMemberTable" class="dataTable" md="12" lg="12" sm="12"
                                :columns="table.unlinkedMember.columns" :data="myUnlinkeds"
                                :options="table.unlinkedMember.options" :theme="table.unlinkedMember.theme">

                                <template slot="uuid" slot-scope="props">
                                    <span v-if="mixinCheckPermission('EDIT_MEMBER_LINKED')" class="btn py-0 px-2"
                                        @click="showUpdateUnlinkedForm(props.row.uuid)">
                                        <i class="fa fa-pencil"></i>
                                    </span>
                                    <span v-if="mixinCheckPermission('EDIT_MEMBER_LINKED')" class="btn py-0 px-2"
                                        @click="deleteUnlinkedMember(props.row.uuid)">
                                        <i class="fa fa-trash"></i>
                                    </span>
                                </template>
                            </v-client-table>
                        </b-card>

                        <b-modal ref="createUnlinkedModal" hide-footer size="lg" title="Agregar Socio Vinculado"
                            centered @hidden="resetUnlinkedMember">
                            <unlinked-member-form v-if="!unlinkedMember.uuid" :initialUnlinkedMember="unlinkedMember"
                                @submit-query-category="createUnlinkedMember($event)">
                            </unlinked-member-form>
                        </b-modal>

                        <b-modal ref="updateUnlinkedModal" hide-footer size="lg" title="Editar Socio Vinculado" centered
                            @hidden="resetUnlinkedMember">
                            <unlinked-member-form v-if="!!unlinkedMember.uuid" :initialUnlinkedMember="unlinkedMember"
                                @submit-query-category="updateUnlinkedMember($event)">
                            </unlinked-member-form>
                        </b-modal>
                    </b-row>

                    <b-row class="m-0">
                        <b-card class="w-100">
                            <b-row slot="header" class="m-0 p-0 justify-content-between align-items-center">
                                <span>Actividades CNAE</span>
                                <span v-if="mixinCheckPermission('EDIT_MEMBER_CNAES')" class="btn p-0"
                                    @click="showAddCnaeForm()">
                                    <i class="fa fa-plus"></i>
                                </span>
                            </b-row>

                            <v-client-table ref="CnaeTable" class="dataTable" md="12" lg="12" sm="12"
                                :columns="table.cnae.columns" :data="myCnaes" :options="table.cnae.options"
                                :theme="table.cnae.theme">

                                <template slot="uuid" slot-scope="props">
                                    <span v-if="mixinCheckPermission('EDIT_MEMBER_CNAES')" class="btn py-0 px-2"
                                        @click="deleteCnae(props.row.uuid)">
                                        <i class="fa fa-trash"></i>
                                    </span>
                                </template>
                            </v-client-table>
                        </b-card>

                        <b-modal ref="addCnaeModal" hide-footer size="lg" title="Añadir Actividad CNAE" centered>
                            <b-form @submit.prevent="addCnae">
                                <b-row>
                                    <b-col offset-lg="1" lg="10">
                                        <b-form-group label="<strong>Actividad</strong>" label-for="cnae"
                                            :horizontal="true" class="w-100 mt-2 mb-0 text-left">
                                            <cnae-selector name="cnae" v-model="cnae"></cnae-selector>
                                        </b-form-group>
                                    </b-col>
                                </b-row>
                                <b-row class="border-top mt-4 pt-3 px-3 flex-row-reverse">
                                    <button type="submit" class="btn btn-brand btn-primary col-auto btn-lg float-right"
                                        sm="12" :disabled="!cnae">
                                        Guardar
                                    </button>
                                </b-row>
                            </b-form>
                        </b-modal>
                    </b-row>

                    <b-row class="m-0">
                        <b-card class="w-100">
                            <b-row slot="header" class="m-0 p-0 justify-content-between align-items-center">
                                <span>Documentos</span>
                                <span v-if="mixinCheckPermission('EDIT_MEMBER_FILES')" class="btn p-0"
                                    @click="showCreateAttachmentForm">
                                    <i class="fa fa-plus"></i>
                                </span>
                            </b-row>

                            <v-client-table ref="CnaeTable" class="dataTable" md="12" lg="12" sm="12"
                                :columns="table.attachment.columns" :data="myAttachments"
                                :options="table.attachment.options" :theme="table.attachment.theme">

                                <template slot="uuid" slot-scope="props">
                                    <span v-if="mixinCheckPermission('READ_MEMBER_FILES')" class="btn py-0 px-2"
                                        @click="getAttachmentPreview(props.row.uuid)">
                                        <i class="fa fa-download"></i>
                                    </span>
                                    <span v-if="mixinCheckPermission('EDIT_MEMBER_FILES')" class="btn py-0 px-2"
                                        @click="deleteAttachment(props.row.uuid)">
                                        <i class="fa fa-trash"></i>
                                    </span>
                                </template>
                            </v-client-table>
                        </b-card>

                        <b-modal ref="addAttachmentModal" hide-footer size="lg" title="Subir Documento" centered>
                            <b-form @submit.prevent="addAttachment" enctype="multipart/form-data">
                                <b-row>
                                    <b-col offset-lg="1" lg="10">
                                        <b-form-group label="<strong>Documento</strong>" label-for="attachment"
                                            :horizontal="true" class="w-100 mt-2 mb-0 text-left">
                                            <b-form-file id="attachment" v-model="attachment"
                                                placeholder="Seleccione documento...">
                                            </b-form-file>
                                        </b-form-group>
                                    </b-col>
                                </b-row>
                                <b-row class="border-top mt-4 pt-3 px-3 flex-row-reverse">
                                    <button type="submit" class="btn btn-brand btn-primary col-auto btn-lg float-right"
                                        sm="12" :disabled="!attachment">
                                        Guardar
                                    </button>
                                </b-row>
                            </b-form>
                        </b-modal>
                    </b-row>
                </b-container>
            </b-row>
        </b-container>
    </div>
</template>

<script>
import { request } from '@/helpers/services';
import { filterUsers, filterActiveStatusUsers } from '@/helpers/user-helper';
import {
    deleteUnlinkedMember,
    createUnlinkedMember,
    updateUnlinkedMember
} from '@/api/unlinked-member-api';
import {
    applyAgreementToMember,
    stopApplyingAgreementToMember,
    updateMemberCnaes
} from '@/api/member-api';
import { createClientAttachment, deleteClientAttachment } from '@/api/client-api';
import { getAttachmentPreview } from '@/api/attachment-api';
import { isFeeAgreementType, getAgreementTypeByKey } from '@/helpers/agreement-helper';
import Multiselect from 'vue-multiselect';
import { setupCalendar, DatePicker } from 'v-calendar';
import 'v-calendar/lib/v-calendar.min.css';
import UnlinkedMemberForm from '@/components/unlinked-members/UnlinkedMemberForm';
import {
    getMemberAssociatedProjects,
    applyAssociatedProjectToMember,
    stopApplyingAssociatedProjectToMember
} from '@/api/associated-project-api';
import form from '@/helpers/form';
import commonAgreementSelector from '@/components/agreements/CommonAgreementSelector';
import cnaeSelector from '@/components/clients/cnaes/CnaeSelector';

export default {
    name: 'add-partner-tab-4',
    components: {
        'v-date-picker': DatePicker,
        Multiselect,
        UnlinkedMemberForm,
        commonAgreementSelector,
        cnaeSelector
    },
    props: [
        'partner',
        'associatedProjects',
        'simplifiedUsers'
    ],
    data: function () {
        return {

            commercialUsers: [],
            affiliationUsers: [],
            refundUsers: [],

            topmenu: [
                {
                    name: 'Volver',
                    path: '/admin/agreements/list',
                    brand: 'fa fa-arrow-left'
                },
            ],
            entity: {
                businessManager: null,
                affiliationManager: null,
                returnManager: null,
                welcomeMail: null,
                includeMemberCard: null,
                headquartersId: null
            },
            affiliationManagers: [],
            returnManagers: [],
            myAgreements: [],
            selectedAgreement: {
                name: null,
                entity: null,
                type: null,
                start_date: null,
                end_date: null,
                headquarters: []
            },
            newAgreement: {
                agreement: null,
                applicationDate: null
            },
            myAssociatedProjects: [],
            newAssociatedProject: {
                associatedProject: null,
                applicationDate: null
            },
            myUnlinkeds: [],
            unlinkedMember: {
                uuid: null,
                nif: null,
                name: null,
                surname: null,
                sex: null,
                birthday: null,
                email: null,
                phone: null
            },
            myCnaes: [],
            cnae: null,
            myAttachments: [],
            attachment: null,
            table: {
                agreement: {
                    columns: [
                        'name',
                        'applicationDate',
                        'validUntil',
                        'uuid'
                    ],
                    options: {
                        headings: {
                            name: 'Nombre',
                            applicationDate: 'Fecha de aplicación',
                            validUntil: 'Vigente hasta',
                            uuid: {
                                text: '',
                                id: 'fit'
                            }
                        },
                        columnsClasses: {
                            uuid: "fit"
                        },
                        sortable: [],
                        filterable: [],
                        sortIcon: {
                            base: 'fa',
                            up: 'fa-sort-asc',
                            down: 'fa-sort-desc',
                            is: 'fa-sort'
                        },
                        texts: form.tableLabels(),
                        pagination: {
                            chunk: 5,
                            edge: true,
                            nav: 'scroll'
                        }
                    },
                    theme: 'bootstrap4'
                },
                associatedProject: {
                    columns: [
                        'uuid',
                        'name',
                        'applicationDate'
                    ],
                    options: {
                        headings: {
                            name: 'Nombre',
                            applicationDate: 'Fecha de aplicación',
                            uuid: {
                                text: '',
                                id: 'fit'
                            }
                        },
                        columnsClasses: {
                            uuid: "fit"
                        },
                        sortable: [],
                        filterable: [],
                        sortIcon: {
                            base: 'fa',
                            up: 'fa-sort-asc',
                            down: 'fa-sort-desc',
                            is: 'fa-sort'
                        },
                        texts: form.tableLabels(),
                        pagination: {
                            chunk: 5,
                            edge: true,
                            nav: 'scroll'
                        }
                    },
                    theme: 'bootstrap4'
                },
                unlinkedMember: {
                    columns: [
                        'nif',
                        'name',
                        'surname',
                        'email',
                        'phone',
                        'uuid'
                    ],
                    options: {
                        headings: {
                            nif: 'DNI',
                            name: 'Nombre',
                            surname: 'Apellidos',
                            email: 'Email',
                            phone: 'Teléfono',
                            uuid: {
                                text: '',
                                id: 'fit'
                            }
                        },
                        columnsClasses: {
                            uuid: "fit"
                        },
                        sortable: [],
                        filterable: [],
                        sortIcon: {
                            base: 'fa',
                            up: 'fa-sort-asc',
                            down: 'fa-sort-desc',
                            is: 'fa-sort'
                        },
                        texts: form.tableLabels(),
                        pagination: {
                            chunk: 5,
                            edge: true,
                            nav: 'scroll'
                        }
                    },
                    theme: 'bootstrap4'
                },
                cnae: {
                    columns: [
                        'code',
                        'activity',
                        'uuid'
                    ],
                    options: {
                        headings: {
                            code: 'Código',
                            activity: 'Actividad',
                            uuid: {
                                text: '',
                                id: 'fit'
                            }
                        },
                        columnsClasses: {
                            uuid: "fit"
                        },
                        sortable: [],
                        filterable: [],
                        sortIcon: {
                            base: 'fa',
                            up: 'fa-sort-asc',
                            down: 'fa-sort-desc',
                            is: 'fa-sort'
                        },
                        texts: form.tableLabels(),
                        pagination: {
                            chunk: 5,
                            edge: true,
                            nav: 'scroll'
                        }
                    },
                    theme: 'bootstrap4'
                },
                attachment: {
                    columns: [
                        'name',
                        'uuid'
                    ],
                    options: {
                        headings: {
                            name: 'Nombre',
                            uuid: {
                                text: '',
                                id: 'fit'
                            }
                        },
                        columnsClasses: {
                            uuid: "fit"
                        },
                        sortable: [],
                        filterable: [],
                        sortIcon: {
                            base: 'fa',
                            up: 'fa-sort-asc',
                            down: 'fa-sort-desc',
                            is: 'fa-sort'
                        },
                        texts: form.tableLabels(),
                        pagination: {
                            chunk: 5,
                            edge: true,
                            nav: 'scroll'
                        }
                    },
                    theme: 'bootstrap4'
                },
            }
        }
    },
    computed: {
        memberAssociatedProjects() {
            return this.associatedProjects.filter((associatedProject) => {
                return !this.myAssociatedProjects.find((myAssociatedProject) => {
                    return associatedProject.uuid === myAssociatedProject.uuid;
                });
            });
        }
    },
    mounted() {
        this.entity = Object.assign({}, this.entity, this.partner);
        this.getAgreements();
        this.getMemberAssociatedProjects();
        this.getUnlinkedMembers();
        this.getCnaes();
        this.getAttachments();
        this.sortUsers();

    },
    methods: {

        sortUsers() {
            for (let user of this.simplifiedUsers) {
                switch (user.department) {
                    case 'COMERCIAL':
                        if(user.status.value === 1) {
                          this.commercialUsers.push(user);
                        }
                        break;
                    case 'GESTION SOCIOS':
                        this.affiliationUsers.push(user);
                        break;
                    case 'ADMINISTRACION':
                        this.refundUsers.push(user);
                        break;
                }
            }
        },

        filterUsers: filterUsers,
        async getMemberAssociatedProjects() {
            getMemberAssociatedProjects(this.partner.uuid).then((associatedProjects) => this.myAssociatedProjects = associatedProjects);
            await this.$emit('getActivity');
        },
        getAgreements() {
            this.requests('members/' + this.partner.uuid + '/agreements', 'get', 200, 'myAgreements');
        },
        getUnlinkedMembers() {
            this.requests('members/' + this.partner.uuid + '/unlinked-members', 'get', 200, 'myUnlinkeds');
        },
        getCnaes() {
            this.requests('members/' + this.partner.uuid + '/cnae', 'get', 200, 'myCnaes');
        },
        getAttachments() {
            this.requests('clients/' + this.partner.uuid + '/attachments', 'get', 200, 'myAttachments');
        },
        async requests(path, method, okCode, entity) {
            this.$_loadingMixin_showLoading();
            this[entity] = await request(path, method, okCode);
            this.$_loadingMixin_hideLoading();
            await this.$emit('getActivity');
        },

        store() {
            this.$_loadingMixin_showLoading();
            try {
                request('/members/' + this.partner.uuid + '/steps/4', 'post', 200, this.entity).then(member => {
                    this.setPartner(member);
                    this.$_loadingMixin_hideLoading();
                });
            } catch (error) {
                this.$_loadingMixin_hideLoading();
            }
        },
        setPartner(entity) {
            this.$emit('sendPartner', entity);
        },
        setAgreementInfo(agreement) {
            this.selectedAgreement.name = agreement.name;
            this.selectedAgreement.entity = agreement.entity;
            this.selectedAgreement.type = agreement.type;
            this.selectedAgreement.start_date = agreement.start_date;
            this.selectedAgreement.end_date = agreement.end_date;
            this.selectedAgreement.headquarters = agreement.headquarters;
        },
        showAgreement(uuid) {
            let agreement = this.myAgreements.find(agreement => (agreement.uuid === uuid));
            if (agreement) {
                this.setAgreementInfo(agreement);
                this.$refs.infoAgreementModal.show();
            }
        },
        getAgreementTypeName(type) {
            return getAgreementTypeByKey(type);
        },
        deleteAgreement(uuid) {
            swal({
                title: '¿Desea retirar el convenio del socio?',
                text: "Esta operación no se podrá revertir",
                type: 'warning',
                showCancelButton: true,
                cancelButtonText: 'Cancelar',
                confirmButtonText: 'Confirmar',
                buttonsStyling: false,
                confirmButtonClass: 'btn btn-brand btn-primary btn-lg',
                cancelButtonClass: 'btn btn-brand btn-light btn-md mr-4',
                reverseButtons: true
            }).then((response) => {
                if (response.value) {
                    this.$_loadingMixin_showLoading();
                    stopApplyingAgreementToMember(this.partner.uuid, uuid)
                        .then(() => {
                            this.$_notificationMixin_success('Operación completada', 'El convenio se ha dejado de aplicar');
                            this.$_loadingMixin_hideLoading();
                            this.getAgreements();
                        })
                        .catch(() => {
                            this.$_notificationMixin_error('Error en la operación', 'No se ha podido dejar de aplicar el convenio');
                        });
                }
            });
        },
        deleteAssociatedProject(uuid) {
            swal({
                title: '¿Desea retirar el proyecto asociado del socio?',
                text: "Esta operación no se podrá revertir",
                type: 'warning',
                showCancelButton: true,
                cancelButtonText: 'Cancelar',
                confirmButtonText: 'Confirmar',
                buttonsStyling: false,
                confirmButtonClass: 'btn btn-brand btn-primary btn-lg',
                cancelButtonClass: 'btn btn-brand btn-light btn-md mr-4',
                reverseButtons: true
            }).then((response) => {
                if (response.value) {
                    this.$_loadingMixin_showLoading();
                    stopApplyingAssociatedProjectToMember(this.partner.uuid, uuid)
                        .then(() => {
                            this.$_notificationMixin_success('Operación completada', 'El proyecto se ha dejado de aplicar');
                            this.$_loadingMixin_hideLoading();
                            this.getMemberAssociatedProjects();
                        })
                        .catch(() => {
                            this.$_notificationMixin_error('Error en la operación', 'No se ha podido dejar de aplicar el proyecto');
                        });
                }
            });
        },
        resetNewAgreement() {
            this.newAgreement.agreement = null;
            this.newAgreement.applicationDate = new Date();
        },
        resetNewAssociatedProject() {
            this.newAssociatedProject.associatedProject = null;
            this.newAssociatedProject.applicationDate = null;
        },
        showAddAgreementForm() {
            this.resetNewAgreement();
            this.$refs.addAgreementModal.show();
        },
        showAddAssociatedProjectForm() {
            this.resetNewAssociatedProject();
            this.$refs.addAssociatedProjectModal.show();
        },
        async addAgreement() {
            if (!!this.newAgreement.agreement && !!this.newAgreement.agreement.uuid) {
                this.$_loadingMixin_showLoading();
                await applyAgreementToMember(
                    this.partner.uuid,
                    this.newAgreement.agreement.uuid,
                    this.newAgreement.applicationDate
                )
                    .then(() => {
                        this.$_notificationMixin_success('Operación completada', 'El convenio ha sido aplicado');
                        this.$refs.addAgreementModal.hide();
                        this.getAgreements();
                    })
                    .catch(() => {
                        this.$_notificationMixin_error('Error en la operación', 'No se ha podido aplicar el convenio');
                    });
                this.$_loadingMixin_hideLoading();
            }
        },
        async addAssociatedProject() {
            if (!!this.newAssociatedProject.associatedProject && !!this.newAssociatedProject.associatedProject.uuid) {
                this.$_loadingMixin_showLoading();
                await applyAssociatedProjectToMember(
                    this.partner.uuid,
                    this.newAssociatedProject.associatedProject.uuid,
                    this.newAssociatedProject.applicationDate
                )
                    .then(() => {
                        this.$_notificationMixin_success('Operación completada', 'El proyecto ha sido aplicado');
                        this.$refs.addAssociatedProjectModal.hide();
                        this.getMemberAssociatedProjects();
                    })
                    .catch(() => {
                        this.$_notificationMixin_error('Error en la operación', 'No se ha podido aplicar el proyecto');
                    });
                this.$_loadingMixin_hideLoading();
            }
        },
        setUnlinkedMember(unlinkedMember) {
            this.unlinkedMember.uuid = unlinkedMember.uuid;
            this.unlinkedMember.nif = unlinkedMember.nif;
            this.unlinkedMember.name = unlinkedMember.name;
            this.unlinkedMember.surname = unlinkedMember.surname;
            this.unlinkedMember.sex = unlinkedMember.sex;
            this.unlinkedMember.birthday = unlinkedMember.birthday;
            this.unlinkedMember.email = unlinkedMember.email;
            this.unlinkedMember.phone = unlinkedMember.phone;
        },
        resetUnlinkedMember() {
            this.setUnlinkedMember({
                uuid: null,
                nif: null,
                name: null,
                surname: null,
                sex: null,
                birthday: null,
                email: null,
                phone: null
            });
        },
        deleteUnlinkedMember(uuid) {
            swal({
                title: '¿Desea eliminar el socio vinculado?',
                text: "Esta operación no se podrá revertir",
                type: 'warning',
                showCancelButton: true,
                cancelButtonText: 'Cancelar',
                confirmButtonText: 'Confirmar',
                buttonsStyling: false,
                confirmButtonClass: 'btn btn-brand btn-primary btn-lg',
                cancelButtonClass: 'btn btn-brand btn-light btn-md mr-4',
                reverseButtons: true
            }).then((response) => {
                if (response.value) {
                    this.$_loadingMixin_showLoading();
                    deleteUnlinkedMember(uuid)
                        .then(() => {
                            this.$_notificationMixin_success('Operación completada', 'El socio vinculado ha sido eliminado');
                            this.$_loadingMixin_hideLoading();
                            this.getUnlinkedMembers();
                        })
                        .catch(() => {
                            this.$_notificationMixin_error('Error en la operación', 'No se ha podido eliminar el socio vinculado');
                        });
                }
            });
        },
        showCreateUnlinkedForm() {
            this.resetUnlinkedMember();
            this.$refs.createUnlinkedModal.show();
        },
        async createUnlinkedMember(unlinkedMember) {
            this.$_loadingMixin_showLoading();
            await createUnlinkedMember(
                this.partner.uuid,
                unlinkedMember.nif,
                unlinkedMember.name,
                unlinkedMember.surname,
                unlinkedMember.sex,
                unlinkedMember.birthday,
                unlinkedMember.email,
                unlinkedMember.phone
            )
                .then(() => {
                    this.$_notificationMixin_success('Operación completada', 'El socio vinculado ha sido creado');
                    this.$refs.createUnlinkedModal.hide();
                    this.getUnlinkedMembers();
                })
                .catch(() => {
                    this.$_notificationMixin_error('Error en la operación', 'El NIF ingresado ya es socio o ya se encuentra vinculado a un socio');
                });
            this.$_loadingMixin_hideLoading();
        },
        showUpdateUnlinkedForm(uuid) {
            let unlinkedMember = this.myUnlinkeds.find(unlinked => (unlinked.uuid === uuid));
            if (unlinkedMember) {
                this.setUnlinkedMember(unlinkedMember);
                this.$refs.updateUnlinkedModal.show();
            }
        },
        async updateUnlinkedMember(unlinkedMember) {
            this.$_loadingMixin_showLoading();
            await updateUnlinkedMember(
                unlinkedMember.uuid,
                unlinkedMember.nif,
                unlinkedMember.name,
                unlinkedMember.surname,
                unlinkedMember.sex,
                unlinkedMember.birthday,
                unlinkedMember.email,
                unlinkedMember.phone
            )
                .then(() => {
                    this.$_notificationMixin_success('Operación completada', 'El socio vinculado ha sido actualizado');
                    this.$refs.updateUnlinkedModal.hide();
                    this.getUnlinkedMembers();
                })
                .catch(() => {
                    this.$_notificationMixin_error('Error en la operación', 'No se ha podido actualizar el socio vinculado');
                });
            this.$_loadingMixin_hideLoading();
        },
        deleteCnae(uuid) {
            swal({
                title: '¿Desea retirar la actividad del socio?',
                text: "Esta operación no se podrá revertir",
                type: 'warning',
                showCancelButton: true,
                cancelButtonText: 'Cancelar',
                confirmButtonText: 'Confirmar',
                buttonsStyling: false,
                confirmButtonClass: 'btn btn-brand btn-primary btn-lg',
                cancelButtonClass: 'btn btn-brand btn-light btn-md mr-4',
                reverseButtons: true
            }).then((response) => {
                if (response.value) {
                    this.$_loadingMixin_showLoading();

                    let cnaes = this.myCnaes.filter(cnae => (cnae.uuid !== uuid));
                    let cnaesIds = cnaes ? cnaes.map(cnae => (cnae.uuid)) : [];

                    updateMemberCnaes(this.partner.uuid, cnaesIds)
                        .then(() => {
                            this.$_notificationMixin_success('Operación completada', 'Se ha retirado la actividad CNAE');
                            this.$_loadingMixin_hideLoading();
                            this.getCnaes();
                        })
                        .catch(() => {
                            this.$_loadingMixin_hideLoading();
                            this.$_notificationMixin_error('Error en la operación', 'No se ha retirado la actividad CNAE');
                        });
                }
            });
        },
        showAddCnaeForm() {
            this.cnae = null;
            this.$refs.addCnaeModal.show();
        },
        async addCnae() {
            if (this.cnae.uuid) {
                this.$_loadingMixin_showLoading();
                let cnaesIds = this.myCnaes.map(cnae => (cnae.uuid));
                cnaesIds.push(this.cnae.uuid);

                await updateMemberCnaes(this.partner.uuid, cnaesIds)
                    .then(() => {
                        this.$_notificationMixin_success('Operación completada', 'Se ha añadido la actividad CNAE');
                        this.$refs.addCnaeModal.hide();
                        this.getCnaes();
                    })
                    .catch(() => {
                        this.$_notificationMixin_error('Error en la operación', 'No se ha añadido la actividad CNAE');
                    });
                this.$_loadingMixin_hideLoading();
            }
        },
        showCreateAttachmentForm() {
            this.$refs.addAttachmentModal.show();
        },
        async addAttachment() {
            this.$_loadingMixin_showLoading();
            await createClientAttachment(this.partner.uuid, this.attachment)
                .then(() => {
                    this.$_notificationMixin_success('Operación completada', 'Se ha subido el documento');
                    this.$refs.addAttachmentModal.hide();
                    this.getAttachments();
                })
                .catch(() => {
                    this.$_notificationMixin_error('Error en la operación', 'No se ha subido el documento');
                });
            this.$_loadingMixin_hideLoading();
        },
        deleteAttachment(uuid) {
            swal({
                title: '¿Desea eliminar el documento?',
                text: "Esta operación no se podrá revertir",
                type: 'warning',
                showCancelButton: true,
                cancelButtonText: 'Cancelar',
                confirmButtonText: 'Confirmar',
                buttonsStyling: false,
                confirmButtonClass: 'btn btn-brand btn-primary btn-lg',
                cancelButtonClass: 'btn btn-brand btn-light btn-md mr-4',
                reverseButtons: true
            }).then((response) => {
                if (response.value) {
                    this.$_loadingMixin_showLoading();

                    deleteClientAttachment(this.partner.uuid, uuid)
                        .then(() => {
                            this.$_notificationMixin_success('Operación completada', 'Se ha eliminado el documento');
                            this.$_loadingMixin_hideLoading();
                            this.getAttachments();
                        })
                        .catch(() => {
                            this.$_loadingMixin_hideLoading();
                            this.$_notificationMixin_error('Error en la operación', 'No se ha eliminado el documento');
                        });
                }
            });
        },
        async getAttachmentPreview(uuid) {
            this.$_loadingMixin_showLoading();
            await getAttachmentPreview(uuid)
                .then((blob) => {
                    window.open(URL.createObjectURL(blob));
                })
                .catch(() => {
                    this.$_notificationMixin_error("Se ha producido un error", "No hemos podido recuperar la previsualización del documento");
                });
            this.$_loadingMixin_hideLoading();
        }
    }
}
</script>

<style scoped>
i {
    color: #025542;
}
</style>
